import "./scss/CTT.scss";
import "./css/leaflet.css";

import WooCommerce from "./js/CTT-woo-commerce.js";
import CTTWidget from "./js/CTT-widget";

/**
 * Class CTT depends on jQuery.
 * Check if we are meant to append a map
 *
 * Platform dependent functions marked with   * @platformDependent
 */
class CTT {
  constructor(ajax_url) {
    this.markers = []; //pickup {lat, lng}
    this.isMapLoaded = false;
    this.gmaps_key =
      typeof CTT_maps_key == "undefined" ? "" : CTT_maps_key;
    this.openMapMarkerIcons = {};
    this.ajax_url = ajax_url; // platform dependent

    // ✅ Track if scripts are preloading
    this.scriptsPreloaded = false;
    this.addressPreGeocoded = false;

    this.platform = new WooCommerce(this.ajax_url);

    this.platform.isCheckout();
    this.init();
  }

  init() {
    this.CTTWidget = new CTTWidget({
      host: "https://CTT.me",
      address: this.platform.getShippingData().Address,
      labels: {},
      mapParentContainer: "body",
      buttonParentContainer: "body",
      buttonClass: "",
      ajax_url: this.ajax_url,
      carrierId: this.platform.getShippingData().CarrierId,
      onPointSelected: () => {},
      gmapskey:
        typeof CTT_maps_key == "undefined" ? "" : CTT_maps_key,
    });
    this.CTTWidget.init();

    // ✅ Preload map resources in the background
    this.preloadMapResources();
  }

  /**
   * ✅ NEW: Preload map scripts and geocode address in background
   */
  preloadMapResources() {
    setTimeout(() => {
      // ✅ 1. Preload map scripts
      if (this.CTTWidget.mapinterface && !this.scriptsPreloaded) {
        this.scriptsPreloaded = true;

        if (jQuery("#sw").length === 0) {
          this.CTTWidget.addMapHtml();
        }
      }
    }, 2000);
  }
  /**
   * ✅ NEW: Pre-fetch pickup points in background
   */
  preFetchPickupPoints() {
    // Only if we have carrier ID and geocoded address
    if (
      !this.CTTWidget.carrier_id ||
      !this.CTTWidget.options.address.Lat
    ) {
      return;
    }

    const req = {
      Address: this.CTTWidget.options.address,
      CarrierId: this.CTTWidget.carrier_id,
      action: "CTT_pickup_locations",
    };

    jQuery
      .getJSON(this.ajax_url, req, (data) => {
        if (data && data.Point && data.Point.length > 0) {
          // ✅ Cache the results
          const cacheKey = this.CTTWidget.hashLatLng({
            lat: this.CTTWidget.options.address.Lat,
            lng: this.CTTWidget.options.address.Long,
          });

          this.CTTWidget.cacheResults[cacheKey] = data;
        }
      })
      .fail(() => {
        console.log("⚠️ Pre-fetch failed (not critical)");
      });
  }

  getPickupLocations(evt) {
    const carrierId =
      parseInt(jQuery("#shipping_carrier_id").val()) ||
      (window.CTTPickupManager &&
        window.CTTPickupManager.carrier_id);
    if (carrierId) {
      this.CTTWidget.carrier_id = carrierId;
      this.CTTWidget.setCarrierId &&
        this.CTTWidget.setCarrierId(carrierId);
    }
    // ✅ Remove any stale loaders before opening
    jQuery(".CTT-loader-btn").stop(true, true).remove();
    this.CTTWidget.openMap(); // openMap() handles its own loader
  }
}

jQuery(function () {
  if (typeof woocommerce_params != "undefined") {
    window.CTT = new CTT(woocommerce_params.ajax_url);
  }
});
